<!--
订单

使用说明：

<OrderItem
    :order="{Order}"
/>

Order={
        orderId: 0, 
        orderNo: '201813154613218', //订单编号
        price: 12000, //订单金额
        status: 1, //订单状态，0表示未完成, 1表示已完成
        product: {
        productId: 0,
        img: 'https://m.360buyimg.com/mobilecms/s750x750_jfs/t2644/302/3542165274/391846/c6df5587/57904959N117574a2.jpg',
        name: '雅鹿自由自在床褥床上用品泰国天然乳胶床垫床褥榻榻米床垫厚度 乳胶+椰棕复合床垫8cm加厚床褥 180*200cm',
        price: 12000,
        sale: 999,
        skuType: 0, //skuType: integer - 订单商品类型 0: UNKNOWN 1: VIRTUAL 2: JINGDONG_PHYSICAL 3: MANUAL_PHYSICAL
        sku: {
            skuId: 0,
            name: '0.5m'
        }
        }
    }
-->
<template>
  <div class="order-wrap">
    <div class="order-head" @click="viewOrder">
      <span>订单编号：{{order.orderNo}}</span>
      <!-- 大玩家处理 -->
      <template v-if="easyUser">
        <span class="order-status" v-if="order.status==0 && !order.expired">待确认</span>
        <span class="order-status" v-if="order.status==0 && order.expired">已过期</span>
        <span class="order-status" v-if="order.status==1">已确认</span>
        <span class="order-status" v-if="order.status==2">已取消</span>
      </template>
      <template v-else>
        <span class="order-status" v-if="order.status==1">已完成</span>
        <span class="order-status" v-if="order.status==0">未完成</span>
      </template>
    </div>
    <div class="order-body" v-for="product in order.products" :key="product.id" @click="viewOrder">
      <div class="left">
        <Icon class="img" :img="product.img" size="”cover“"></Icon>
      </div>
      <div class="right">
        <div class="title">{{product.name}}</div>
        <div class="sku">{{product.sku.name}}</div>
        <div class="price">{{product.price}}{{priceUnit}}</div>
        <div class="count">x{{product.count}}</div>
      </div>
    </div>
    <div class="order-summary">
      共 {{order.products.length}} 件商品，合计：
      <span class="price">{{order.price}}{{priceUnit}}</span>
    </div>
    <div class="order-foot">
      <template v-if="easyUser">
        <!-- 大玩家 底部 -->
        <template v-if="order.status == 0 && !order.expired">
          <!-- 待确认 且 未过期 -->
          <a href="javascript:;" @click="easyOrderCancel(order.orderNo)">取消</a>
          <a href="javascript:;" @click="easyOrderConfirm">去确认</a>
        </template>
        <template v-if="order.deliveryStatus == 3">
          <!-- 查看物流 -->
          <a
            href="javascript:;"
            @click="()=>{$router.push('/pages/orders/Logistics?orderno='+order.orderNo)}"
          >查看物流</a>
        </template>
        <template v-if="order.skuType == 1 && order.status == 1">
          <!-- 查看卡包 -->
          <a
            href="javascript:;"
            @click="()=>{$router.push('/pages/orders/Wallet?orderno='+order.orderNo)}"
          >查看卡包</a>
        </template>
      </template>
      <template v-else>
        <template v-if="order.skuType != 1">
          <!-- 京东、手动发货等商品 -->
          <template v-if="order.status==0">
            <a
              href="javascript:;"
              @click="()=>{$router.push('/pages/orders/Logistics?orderno='+order.orderNo)}"
              v-if="order.logisticsOrderno"
            >查看物流</a>
          </template>
        </template>
        <template v-else>
          <!-- 虚拟卡密商品 -->
          <a
            href="javascript:;"
            @click="()=>{$router.push('/pages/orders/Wallet?orderno='+order.orderNo)}"
            v-if="!order.virtualCardObsoleted"
          >去卡包查看</a>
          <a href="javascript:;" v-else>该卡已删除</a>
        </template>
      </template>
    </div>

    <!-- 大玩家提取码 -->
    <confirmModal v-if="showConfirmModal" :code="order.comfirmCode" @close="handleCloseModal" />
  </div>
</template>

<script>
import api from "../../api";
import store from "../../api/store";
import confirmModal from "@/components/easy/confirmModal";

export default {
  props: ["order"],
  components: { confirmModal },
  data() {
    return {
      priceUnit: store.loginedUser.config.pointName,
      easyUser: store.loginedUser.easyUser,
      showConfirmModal: false
    };
  },
  methods: {
    viewOrder() {
      if (this.easyUser) {
        // 产品说大玩家暂时不需要进入订单详情页，暂时！
        return;
      }
      if (this.order.skuType != 1) {
        //实物商品
        this.$routerPush(
          this,
          "/pages/orders/detail?orderno=" + this.order.orderNo
        );
      } else {
        //虚拟商品
        if (!this.order.virtualCardObsoleted) {
          this.$routerPush(
            this,
            "/pages/orders/Wallet?orderno=" + this.order.orderNo
          );
        }
      }
    },
    // 大玩家
    easyOrderCancel(orderno) {
      this.$confirmDialog("是否取消该订单？", btn => {
        if (btn == "确定") {
          if (this.order.skuType == 1) {
            // 虚拟商品
            api.easy.easyOrderCancelVmall(
              orderno,
              res => {
                console.log(res);
                this.$alertDialog(`取消订单成功`);
                this.$emit("reload");
              },
              r => {
                err => {
                  this.$alertDialog(err.msg);
                };
              }
            );
          } else {
            api.easy.easyOrderCancelJD(
              orderno,
              res => {
                console.log(res);
                this.$alertDialog(`取消订单成功`);
                this.$emit("reload");
              },
              r => {
                err => {
                  this.$alertDialog(err.msg);
                };
              }
            );
          }
        }
      });
    },
    easyOrderConfirm() {
      this.showConfirmModal = true;
    },
    handleCloseModal() {
      this.showConfirmModal = false;
    }
  }
};
</script>

<style lang="less">
.order-wrap {
  background: #fff;
  //   margin-bottom: 2.66vw;

  .order-head {
    border-bottom: 1px solid #e6e6e6;
    width: 92vw;
    margin: 0 auto;
    line-height: 11.73vw;
    color: #424242;
    font-size: 2.666vw;
  }
  .order-body {
    border-bottom: 1px solid #e6e6e6;
    height: 29.06vw;
    position: relative;
    z-index: 3;

    .left {
      position: absolute;
      left: 4.133vw;
      top: 2vw;

      .img {
        width: 25.06vw;
        height: 25.06vw;
      }
    }
    .right {
      position: absolute;
      left: 32.26vw;
      top: 2vw;
      width: 63.73vw;

      .title {
        font-size: 3.2vw;
        line-height: 1.5em;
        min-height: 2em;
        max-height: 3em;
        overflow: hidden;
        color: #3c3c3c;
      }

      .sku {
        font-size: 2.93vw;
        color: #999999;
        line-height: 1.2em;
      }

      .price {
        font-size: 3.46vw;
        color: #3c3c3c;
      }

      .count {
        position: absolute;
        right: 0;
        bottom: 0;
        font-size: 3.46vw;
        color: #989898;
      }
    }
  }
  .order-summary {
    color: #999;
    font-size: 3.2vw;
    text-align: right;
    line-height: 12vw;

    .price {
      color: #3c3c3c;
      font-size: 3.466vw;
      margin-right: 4vw;
    }
  }
  .order-foot {
    background: #f7f7f7;
    text-align: right;
    padding: 2.4vw 4vw;

    a {
      display: inline-block;
      text-align: center;
      font-size: 3.2vw;
      line-height: 7.2vw;
      color: #414141;
      border: 1px solid #414141;
      border-radius: 3.6vw;
      padding: 0 3.2vw;
      background: #fff;
    }
  }
}

.order-status {
  float: right;
  color: @themeColor;
  font-size: 3.2vw;
}
</style>





// WEBPACK FOOTER //
// src/components/orders/OrderItem.vue